import styled from 'styled-components';
import LinkHandler from '../link-handler';
import ResponsiveImage from '../image/responsive.js';
import { breakpoint } from '../theme/breakpoint';

export const LinkStyled = styled(LinkHandler)`
  display: flex;
  align-items: center;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.palette.white};
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spacing.standard};
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  ${breakpoint.tablet`
    margin-bottom: 0;
  `};
`;

export const ImageWrapper = styled.div`
  position: relative;
  background: ${({ theme }) => theme.palette.lightBackground};
  // aspect ratio sizer to prevent reflow on image load
  padding-top: 56%;
`;

export const CardImage = styled(ResponsiveImage)`
  // aspect ratio placement to prevent reflow on image load
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
`;

export const TextWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing.standard};
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;

  ${breakpoint.tablet`
    min-height: 170px;
  `};
`;

export const CardText = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.small};
`;

export const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: auto;
`;
